export default __webpack_public_path__ + "static/media/330_store04-it-mobile.1767e6fa.png";